/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AppReleaseControllerDownloadCurrentChannelFeedFromBasePath$Params {
  channel: string;
  platform: string;
  arch: string;
}

export function appReleaseControllerDownloadCurrentChannelFeedFromBasePath(http: HttpClient, rootUrl: string, params: AppReleaseControllerDownloadCurrentChannelFeedFromBasePath$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, appReleaseControllerDownloadCurrentChannelFeedFromBasePath.PATH, 'get');
  if (params) {
    rb.path('channel', params.channel, {});
    rb.path('platform', params.platform, {});
    rb.path('arch', params.arch, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

appReleaseControllerDownloadCurrentChannelFeedFromBasePath.PATH = '/api/app-releases/channels/current/{channel}/{platform}/{arch}';
